import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from "@angular/forms";

@Component({
    selector: 'medsurf-design-form-control-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './form.form-control.design.html',
    styleUrls: ['./form.form-control.design.scss'],
    standalone: false
})
export class FormFormControlDesign {
  @Input({ required: true }) formGroup!: FormGroup;
  @Input() className?: string;
  @Output() onSubmit = new EventEmitter();
}
